<!-- eslint-disable linebreak-style -->
<template>
  <div class="page relative">
    <div class="main flex flex-col items-center justify-center">
      <header v-if="!showAdvanced">
        <!-- <h1>What public data are you looking for?</h1>
        <p>
          Provide any search keyword, indicator list or country to get access to its public data
        </p> -->
        <span class="mini__title uppercase block">AI-Powered Data Search</span>
        <h1>Visualize and Interprete <br> African Economic Data</h1>
        <p>
          Uncover In-Depth Statistics, Visualizations, and Reliable Datasets across 15+ Countries and 30,000+
          Indicators on Africa’s Premier Public Data Hub
        </p>
      </header>
      <header v-else>
        <h1>Advanced Search</h1>
        <p>Filter your search by category, indicator and country</p>
      </header>
      <form @submit.prevent="goToSearch()">
        <div class="w-full flex search__wrapper items-center" aria-label="search container">
          <img src="@/assets/svg/search.svg" alt="Search Icon" />
          <textarea v-model="value" @input="autoResize" @keydown.enter.prevent="goToSearch()" ref="textarea" type="search" placeholder="Ask a question"
            name="" id="" class="w-full h-full pt-1" required />
          <button :disabled="isLoading" class="flex justify-center items-center h-full capitalize">search</button>
        </div>
        <!-- <div class="input-container">
          <template v-if="!showAdvanced">
            <k-input v-model="value" label="" reactive type="search"></k-input>
            <ul :class="['search-suggestions', { loading: isSearching }]">
              <div v-if="isSearching">
                <div class="lds-default">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <template v-else>
                <li v-for="searchTerm in sortedSuggestions" :key="searchTerm"
                  @click="$router.push({ name: 'Results', query: { q: searchTerm } })" tabindex="0">
                  {{ searchTerm }}
                </li>
              </template>
</ul>
</template>
<template v-else>
            <div class="advanced-options">
              <k-input v-model="country" :optionsDisplay="countries" label="Country" searchInside="countries"
                type="select"></k-input>
              <k-input v-model="category" :optionsDisplay="categories" label="Category" searchInside="categories"
                type="select" @search="(val) => debounce(fetchIndicators, 500)({ name: val })"></k-input>
              <k-input v-model="indicator" :optionsDisplay="indicators" label="Indicator" searchInside="indicators"
                type="select" @search="(val) => debounce(fetchIndicators, 500)({ name: val, category })"></k-input>
            </div>
          </template>
</div> -->
        <!-- <div v-if="!showAdvanced" class="ctas">
          <k-button :disabled="!value" short type="submit" variant="primary">Search</k-button>
          <k-button short variant="link" @click="showAdvanced = true"> Advanced Search</k-button>
        </div>
        <div v-if="showAdvanced" class="ctas advanced">
          <k-button :disabled="!advancedSearchReady" class="submit-btn" short type="submit" variant="primary"
            @click="advancedSearch">Submit
          </k-button>
          <k-button short variant="tertiary" @click="showAdvanced = false">Cancel</k-button>
        </div> -->
      </form>
      <section v-for="(chunk, chunkIndex) in chunkedSearches" :key="chunkIndex"
        class=" justify-center search__helper grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
        <button v-for="search in chunk" :key="search.id || search.term" @click="goToSearch(search.term)"
          :disabled="isLoading" class="helper w-full flex items-center justify-center px-2">
          {{ search.term }}
        </button>
      </section>
    </div>

    <!-- <div class="suggested">
      <header>
        <h2>Suggested Articles</h2>
        <k-button class="read-more-btn" short variant="link" @click="$router.push({ name: 'Blog' })">Read More
        </k-button>
      </header>
      <ul class="articles" v-if="suggested.length">
        <li v-for="article in suggested" :key="article.title" class="article"
          @click="$router.push({ name: 'SingleBlog', params: { slug: article.full_slug } })">
          <img :alt="article.name" :src="article.content.image" class="image" />
          <div class="title">
            {{ article.name }}
            <img alt="" src="@/assets/read-more-arrow.svg" />
          </div>
        </li>
      </ul>
      <p v-else>No posts yet</p>
    </div> -->
    <div v-if="isLoading" class="absolute top-0 z-10 h-full w-full custom-bg flex flex-col justify-center items-center">
      <div class="suspense flex justify-center items-center">
        <p class="text-black">Loading....</p>
      </div>
    </div>
  </div>
</template>

<script>
import Search from './Search';


export default Search;
</script>

<style lang="scss" scoped src="./Search.scss"></style>
